import SettingView from 'src/sections/management/setting/view/setting-view';

export default function Setting() {
  return <SettingView />;
}
